import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowUp, Mail, Phone } from "lucide-react";
import KabXLogo from "../assets/icons/KABX_logo.svg";
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showBackToTop, setShowBackToTop] = useState(false);

  // Smooth Scroll with header offset
  const smoothScrollTo = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (!el) return;

    const headerOffset = 80;
    const elementPosition = el.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  };

  // Scroll to very top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Show Back To Top toggle
  useEffect(() => {
    const handleScroll = () => setShowBackToTop(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About Us" },
    { id: "drive", label: "Drive with Us" },
    { id: "impact", label: "Impact" },
    { id: "ownership", label: "Our Ownership" },
  ];

  // give unique ids for different service links
  const serviceItems = [
    { id: "ride", label: "Standard Rides" },
    { id: "services", label: "Women-for-Women" },
    { id: "services", label: "Group Rides" },
  ];

  const supportItems = [
    { id: "contact", label: "Contact" },
    { id: "safety", label: "Safety" },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* BRAND */}
          <div className="footer-brand">
            <img src={KabXLogo} alt="KabX" className="footer-logo" />
            <p className="footer-tagline">Choose Canadian. Choose Community. Choose KabX.</p>

            <div className="footer-contact">
              <p className="contact-phone"><Phone size={20} /> 1-800-KabX-1</p>
              <p className="contact-email"><Mail size={20} /> support@kabx.ca</p>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-list">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      smoothScrollTo(item.id);
                    }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* SERVICES */}
          <div className="footer-links">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-list">
              {serviceItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      smoothScrollTo(item.id);
                    }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
{/* LEGAL */}
          <div className="footer-links">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-list">
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/cancellation-policy">Cancellation Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
            </ul>
          </div>
          
          {/* SUPPORT */}
          <div className="footer-links">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-list">
              {supportItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      smoothScrollTo(item.id);
                    }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          
        </div>

        {/* BOTTOM SECTION */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} KabX Inc. All Rights Reserved. Proudly Canadian-Owned.</p>
          </div>

          <div className="footer-app-links">
            <a href="#" className="footer-app-btn">
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
            </a>
            <a href="#" className="footer-app-btn">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" />
            </a>
          </div>

          {showBackToTop && (
            <button
              onClick={scrollToTop}
              className="back-to-top-btn"
              aria-label="Back to top"
              data-testid="back-to-top-btn"
            >
              <ArrowUp className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
